<template>
  <div class="wrapper">
    <!-- <div class="structureSide">
      <el-tree
        :data="departmentGroupTree"
        :props="propsSet"
        @node-click="treeClick"
      ></el-tree>
    </div> -->
    <div class="detailSide">
      <div class="actBar">
        <!-- <el-button type="primary" icon="el-icon-plus" size="small">
          新增角色
        </el-button>
        <el-input v-model="" size="small" placeholder="请输入角色名称"></el-input> -->
      </div>
      <div class="tableBox">
        <div class="actBar">
          <div class="leftSide">
            <el-input
              placeholder="请输入单位名称"
              v-model="searchCondition.companyName"
              style="width: 300px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getData"
              ></el-button> </el-input
            >&emsp;
            <el-button type="primary" icon="el-icon-plus" @click="newCooperator"
              >新增合作单位</el-button
            >
          </div>
          <div class="rightSide">
            <!-- <el-button>手动排序</el-button>
            <el-button>按字母排序</el-button> -->
          </div>
        </div>
        <br />
        <el-table :data="userList" border style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column prop="companyName" label="单位名称" min-width="100">
          </el-table-column>
          <el-table-column
            prop="contactPerson"
            label="单位联系人"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="mobile" label="手机" width="200">
          </el-table-column>
          <el-table-column prop="enable" label="启用" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.enable"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="
                  (value) => {
                    statusEdit(scope.row, value);
                  }
                "
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="expireTime" label="到期时间" width="120">
          </el-table-column>
          <!-- <el-table-column prop="zip" label="最后登录" width="120">
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editUser(scope.row)"
                >编辑</el-button
              >

              <!-- <el-button type="text" size="small" @click="deleteUser(scope.row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="searchCondition.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="searchCondition.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="ifCreate ? '新建合作单位' : '编辑合作单位'"
      :visible.sync="editData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form :model="editData" class="demo-form-inline" label-width="120px">
        <el-form-item label="单位名称">
          <el-input
            v-model="editData.companyName"
            placeholder="请输入单位名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input
            style="width: 300px"
            v-model="editData.contactPerson"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            style="width: 300px"
            v-model="editData.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker
            style="width: 300px"
            size="small"
            v-model="editData.expireTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="请选择到期时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="submitCooperator">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserList,
  searchCooperative,
  addCooperative,
  editCooperative,
} from "@/api/index";
export default {
  data() {
    return {
      ifCreate: true,
      departmentGroupTree: [],
      propsSet: {
        children: "children",
        label: "groupName",
      },
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        companyName: "",
      },
      editData: {
        ifShow: false,
        id: 0,
        mobile: "",
        companyName: "",
        contactPerson: "",
        expireTime: "",
      },
      userList: [],
      roleList: [],
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    treeClick() {},
    getData() {
      searchCooperative(this.searchCondition).then((data) => {
        this.userList = data.rows;
        this.searchCondition.total = data.total;
      });
    },
    editUser(item) {
      this.ifCreate = false;
      Object.assign(this.editData, item);
      this.editData.ifShow = true;
    },
    deleteUser(item) {},
    newCooperator() {
      this.ifCreate = true;
      Object.assign(this.editData, this.$options.data().editData);
      delete this.editData.id;
      this.editData.ifShow = true;
    },
    submitCooperator() {
      if (this.ifCreate) {
        addCooperative(this.editData).then((data) => {
          this.$message.success(data);
          this.editData.ifShow = false;
          this.getData();
        });
      } else {
        editCooperative(this.editData).then((data) => {
          this.$message.success(data);
          this.editData.ifShow = false;
          this.getData();
        });
      }
    },
    statusEdit(item, newValue) {
      item.enable = newValue;
      editCooperative(item).then((data) => {
        this.$message.success(data);
        this.editData.ifShow = false;
        this.getData();
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  //   display: flex;
  min-height: 600px;
  .structureSide {
    flex: 1;
    min-width: 200px;
    margin-right: 10px;
    background: #fff;
  }
  .detailSide {
    flex: 5;
    background: #fff;
    padding: 20px;
  }
  .tableBox {
    .actBar {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
